import _regeneratorRuntime from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _slicedToArray from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import React, { useState } from "react";
import { Dialog, DialogContent, Button, CircularProgress, makeStyles } from "@material-ui/core";
import getPreferenceUI from "../dal/v2";
import { useAuth0 } from "../auth/react-auth0-wrapper";
var useStyles = makeStyles(function () {
  return {
    "@global": {
      "@font-face": [{
        fontFamily: "Barlow",
        fontStyle: "normal",
        fontWeight: 400,
        src: "\n          url(\"https://fonts.googleapis.com/css2?family=Barlow:wght@400;500;600;700&display=swap\")\n        "
      }],
      body: {
        fontFamily: "Barlow, sans-serif"
      }
    },
    dialogPaper: {
      borderRadius: 10,
      width: "520px",
      maxWidth: "520px",
      padding: "0",
      overflow: "hidden"
    },
    dialogTitle: {
      fontSize: "20px",
      fontWeight: 700,
      color: "#0C2340",
      margin: 0,
      padding: "24px 24px 8px 24px"
    },
    dialogContent: {
      fontSize: "16px",
      lineHeight: 1.6,
      color: "#2D2D2D",
      padding: "0 24px"
    },
    list: {
      margin: "0 0 8px 5px"
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "flex-end",
      padding: "0 24px 24px 24px"
    },
    button: {
      color: "#FFFFFF",
      backgroundColor: "#0C2340",
      borderRadius: "6px",
      textTransform: "none",
      fontWeight: 600,
      fontSize: "14px",
      padding: "6px 20px",
      "&:hover": {
        backgroundColor: "#07142A"
      }
    }
  };
});
var NewUIAlertDialog = function NewUIAlertDialog(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose;
  var classes = useStyles();
  var _useAuth = useAuth0(),
    physician = _useAuth.physician,
    setIsV2Ui = _useAuth.setIsV2Ui;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var handleSubmit = function handleSubmit() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              if (!physician) {
                _context.next = 11;
                break;
              }
              _context.prev = 2;
              _context.next = 5;
              return getPreferenceUI.getPreferenceUI(false, true, physician.id);
            case 5:
              response = _context.sent;
              setIsV2Ui(!response.data.prefersLegacyUi);
              onClose();
            case 8:
              _context.prev = 8;
              setLoading(false);
              return _context.finish(8);
            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2,, 8, 11]]);
    }));
  };
  // prevent closing by escape/backdrop
  var handleClose = function handleClose(_event, reason) {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return; // block closing
    }
    onClose();
  };
  return React.createElement(Dialog, {
    open: open,
    onClose: handleClose,
    PaperProps: {
      style: {
        borderRadius: 8,
        overflowX: "hidden"
      }
    }
  }, React.createElement("h2", {
    className: classes.dialogTitle
  }, "Introducing a New Ordering Experience"), React.createElement(DialogContent, {
    style: {
      fontSize: '16px',
      maxHeight: '70vh',
      overflowY: 'auto',
      fontWeight: 400,
      padding: "0px 24px 10px 24px"
    }
  }, React.createElement("div", null, React.createElement("p", null, "We\u2019ve launched a faster, more efficient interface for ordering select Whole Exome Sequencing and Whole Genome Sequencing tests.")), React.createElement("div", null, React.createElement("h4", null, "The new experience features:"), React.createElement("ul", null, React.createElement("li", null, "A simplified step-by-step order flow."), React.createElement("li", null, "Improved clarity for test and sample details.")), React.createElement("p", null, "Prefer the classic view? Use the toggle under your user profile to switch back anytime.")), React.createElement("div", {
    style: {
      width: "100%",
      display: "flex",
      justifyContent: "right",
      marginTop: "2rem"
    }
  }, React.createElement(Button, {
    style: {
      color: "white",
      backgroundColor: "#0C2340",
      borderRadius: "4px"
    },
    size: "medium",
    onClick: handleSubmit,
    color: "primary",
    variant: "contained"
  }, loading ? React.createElement(CircularProgress, {
    size: 8,
    style: {
      color: "white"
    }
  }) : "Get Started"))));
};
export default NewUIAlertDialog;